var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "skip-to",
    attrs: {
      "href": _vm.to,
      "tabindex": _vm.tabindex
    },
    domProps: {
      "textContent": _vm._s(_vm.text)
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.skipPressed.apply(null, arguments);
      },
      "click": function click($event) {
        $event.preventDefault();
        return _vm.skipPressed.apply(null, arguments);
      }
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };